/** Prevents background socket disconnect during an active live session */

import { LIVE_PHASES } from '../constants/liveConfig'

let _active = false

const ACTIVE_LIVE_PHASES = [
  LIVE_PHASES.SOCKET_CONNECTING,
  LIVE_PHASES.LIVEKIT_CONNECTING,
  LIVE_PHASES.CONNECTING,
  LIVE_PHASES.CONNECTED_HOST,
  LIVE_PHASES.CONNECTED_VIEWER,
  LIVE_PHASES.RECONNECTING,
]

export const liveSocketKeepAlive = {
  get hasActiveLiveSession() {
    return _active
  },
  syncFromPhase(phase) {
    _active = ACTIVE_LIVE_PHASES.includes(phase)
  },
  clear() {
    _active = false
  },
}
